/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import { OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import { NavItemEnum } from '../../constants/Mon569SidenavConfig';
import { CREATE_A_BUNDLE, MON569_SCREENS } from '../../constants/Tracking';
import { countrySelector } from '../../selectors/CountrySelectors';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import { hasPaidHubInProductInventorySelector, hasProductVersionInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { useTrackRetail } from '../../selectors/RetailSelectors';
import { useQueryParamsEffect } from '../../utils/queryParamUtils';
import breakpoint from '../../utils/responsiveBreakpoints';
import { useQueryParamTerm } from '../../utils/stateUtils';
import CurrencyPicker from '../common/CurrencyPicker';
import PhoneSupport from '../common/PhoneSupport';
import FailedLoadBanner from '../loading/FailedLoadBanner';
import NavLayout, { HeaderBackdrop } from '../mon569-tabs/NavLayout';
import AddonsAndServicesPickerList from '../plan-builder/AddonsAndServicesPickerList';
import HubPlanPickerList from '../plan-builder/HubPlanPickerList';
import PlanBuilder from '../plan-builder/PlanBuilder';
import SummaryColumn from '../plan-builder/SummaryColumn';
const PageContainer = styled.div.withConfig({
  displayName: "Mon569BundlePage__PageContainer",
  componentId: "sc-1hv2y7o-0"
})(["background-color:", ";"], OLAF);
const ContentContainer = styled.div.withConfig({
  displayName: "Mon569BundlePage__ContentContainer",
  componentId: "sc-1hv2y7o-1"
})(["padding-left:100px;", " ", ""], breakpoint.cs(_t || (_t = _`
    padding: 0 80px 0;
  `)), breakpoint.tablet(_t2 || (_t2 = _`
    padding: 50px 50px;
  `)));
const PageTitle = styled.div.withConfig({
  displayName: "Mon569BundlePage__PageTitle",
  componentId: "sc-1hv2y7o-2"
})(["text-align:start;font-size:32px;margin-bottom:10px;font-weight:600;line-height:40px;"]);
const SubTitle = styled.div.withConfig({
  displayName: "Mon569BundlePage__SubTitle",
  componentId: "sc-1hv2y7o-3"
})(["text-align:start;font-size:16px;margin-bottom:56px;"]);
const FailedContentContainer = styled.div.withConfig({
  displayName: "Mon569BundlePage__FailedContentContainer",
  componentId: "sc-1hv2y7o-4"
})(["max-width:1200px;margin:0 auto;padding:45px 0 0;"]);
const RightColumnWrapper = styled.div.withConfig({
  displayName: "Mon569BundlePage__RightColumnWrapper",
  componentId: "sc-1hv2y7o-5"
})(["width:360px;top:70px;position:sticky;margin-left:40px;", ""], breakpoint.tablet(_t3 || (_t3 = _`
    margin: 0 auto;
  `)));

const Mon569BundlePage = () => {
  useTrackRetail();
  const country = useSelector(countrySelector);
  const activeCurrencyCode = useSelector(activeCurrencySelector);
  useEffect(() => {
    getUsageTracker().setProperties({
      activeCurrencyCode,
      countryTerritory: country
    });
    getUsageTracker().track('pageView', {
      screen: MON569_SCREENS.BUNDLE
    });
  }, []);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const hasPricingAndPurchasingFailed = useSelector(hasPricingAndPurchasingFailedSelector);
  const initialProductConfigurations = useSelector(state => {
    if (!hasPricingAndPurchasingSucceeded || hasPaidHubInProductInventorySelector(state, {
      productLevels: [PROFESSIONAL, ENTERPRISE]
    })) return [];
    return suiteProductConfigurationsSelector(state, {
      productLevel: STARTER
    }).filter(({
      skuId
    }) => !hasProductVersionInProductInventorySelector(state, {
      skuId
    }));
  });
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  if (!hasPricingAndPurchasingSucceeded) return null;
  return /*#__PURE__*/_jsxs(PageContainer, {
    children: [/*#__PURE__*/_jsx(HeaderBackdrop, {}), /*#__PURE__*/_jsx(CurrencyPicker, {}), /*#__PURE__*/_jsx(NavLayout, {
      selectedNavItem: NavItemEnum.BUNDLE,
      children: /*#__PURE__*/_jsxs(ContentContainer, {
        children: [hasPricingAndPurchasingFailed && /*#__PURE__*/_jsx(FailedContentContainer, {
          children: /*#__PURE__*/_jsx(FailedLoadBanner, {
            hasFailed: hasPricingAndPurchasingFailed
          })
        }), hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
          name: "BUNDLE_PAGE"
        }), /*#__PURE__*/_jsx(PageTitle, {
          "data-selenium-id": "page-success",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "bundles.pageTitle"
          })
        }), /*#__PURE__*/_jsx(SubTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "bundles.subtitle"
          })
        }), /*#__PURE__*/_jsxs(PlanBuilder, {
          initialProductConfigurations: initialProductConfigurations,
          allowUpgradesToCrmSuite: true,
          trackingSource: CREATE_A_BUNDLE,
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex-column",
            style: {
              flex: 1
            },
            children: [/*#__PURE__*/_jsx(HubPlanPickerList, {
              productLines: [MARKETING, SALES, SERVICE, CMS, OPERATIONS],
              useCompactTitle: false
            }), /*#__PURE__*/_jsx(AddonsAndServicesPickerList, {
              compact: false,
              defaultOpen: true,
              showServicesSection: true,
              screen: MON569_SCREENS.BUNDLE
            })]
          }), /*#__PURE__*/_jsxs(RightColumnWrapper, {
            children: [/*#__PURE__*/_jsx(SummaryColumn, {
              shareLinkAnchor: "",
              hubsSignupProductOverride: "bundle"
            }), /*#__PURE__*/_jsx(PhoneSupport, {
              className: "m-top-5",
              phoneSourceId: "bundle",
              border: false,
              screen: MON569_SCREENS.BUNDLE
            })]
          })]
        })]
      })
    })]
  });
};

export default Mon569BundlePage;